import dayjs from "dayjs";

export const findMissingDaysBetween = (
	days: dayjs.Dayjs[],
	minDate: dayjs.Dayjs,
	maxDate: dayjs.Dayjs
): dayjs.Dayjs[] => {
	const startDate = minDate.startOf("day");
	const totalDays = maxDate.diff(startDate, "day") + 1;

	return Array.from({ length: totalDays }, (_, i) => startDate.add(i, "day")).filter(
		(day) => !days.some((d) => d.isSame(day, "day"))
	);
};

export const maxBy = <T, U>(array: T[], selector: (element: T) => U): T | undefined => {
	if (array.length === 0) return undefined;

	return array.reduce((max, item) => (selector(item) > selector(max) ? item : max));
};

export const minBy = <T, U>(array: T[], selector: (element: T) => U): T | undefined => {
	if (array.length === 0) return undefined;

	return array.reduce((min, item) => (selector(item) < selector(min) ? item : min));
};
